module.exports = __webpack_public_path__ + "static/media/6.08c715b4.png";